import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
export const client = sanityClient({

    projectId: 'k7q5w7so',
    dataset: 'production',
    apiVersion: '2023-12-01',
    useCdn: false,
    token: 'skuhvlp5123nfbukMm5PDOCeQlHKvyEJCfiuFgHrxnyUzcQt9u2yMcopTwCy6XEYLZ0QIhDLC3rfZUEIUGsUsnZlRFD9J9amKuFrbR6MtrgPubcsDajKXxpxReyAR1MEDzmrXH6mfPqzg48OGkmIzC5nIAAIenHYT43lNEOZegzOodATHCNd',
    ignoreBrowserTokenWarning: true,


})

const builder = imageUrlBuilder(client);



export const urlFor = (source) => builder.image(source)